import React, { useEffect, useState } from "react";
import { useForm, useWatch, Controller } from "react-hook-form";
import { IoCloseOutline } from "react-icons/io5";
import "./JobForm.scss";
import { MultiSelect } from "primereact/multiselect";
import { InputSwitch } from "primereact/inputswitch";
import { PriorityEnumLabels, PriorityEnum, RecordStatusEnum, JobDetailStatusEnum, JobDetailStatusEnumLabels } from "../../enum/enum";
import masterApi from "../../services/masterApi";
import jobApi from "../../services/jobApi";
import CreatableSelect from 'react-select/creatable';
import { Editor } from 'primereact/editor';
import apiService from "../../services/apiService";  // Import from services folder

import Select from 'react-select';
import { toast } from 'react-toastify';
import { ThreeDotLoader } from "../Loader/Loader"; // Add this import



const JobDetailsDTO = require('../../dto/jobDetailsDto');
export const JobForm = ({ closePopup, existingData }) => {
  const { control, register, setValue, watch, handleSubmit, formState: { errors }, reset } = useForm({});
  const searchTextLimit = process.env.REACT_APP_CONFIDENTIAL_SEARCH_TEXT_LIMIT;
  const [departmentLst, setDepartmentLst] = useState([]);
  const [companyLst, setCompanyLst] = useState([]);
  const [accountLst, setAccountLst] = useState([]);
  const [qualificationLst, setQualificationLst] = useState([]);
  const [skillsLst, setSkillsLst] = useState([]);
  const [employmentTypeId, setEmploymentTypeId] = useState([]);
  const [usersLst, setUsersLst] = useState([]);
  const [employmentTypeLst, setemploymentTypeLst] = useState([]);
  const [isPublished,setIsPublished]=useState(false);
  const [isPublishClicked,setIsPublishClicked]=useState(false);
  const [countryLst, setCountryLst] = useState([]);
  const [countryLstApi, setCountryLstApi] = useState([]);
  const [locationsLst, setLocationsLst] = useState([]);
  const [accounts, setAccounts] = useState([])
  const [clientAccountManagerLst, setClientAccountManagerLst] = useState([]);
  const [clientAccountManagers, setClientAccountManagers] = useState([])
  const [searchedUserList, setSearcheduserList] = useState([])
  const [searchedCompany, setSearchedCompany] = useState([])
   const [isLoading, setIsLoading] = useState(false); // Add this state
   const [isEditAndApproved, setIsEditAndApproved] = useState(false);

  const approvalNeeded = useWatch({
    control,
    name: "approvalNeeded",
    defaultValue: false,
  });


  const options = accountLst.map(account => ({
    value: account.ClientId,
    label: account.ClientName
  }));

  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Handle undefined/null values
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const addDepartmentDetails = async (departments) => {  
    try {      
      const payload = {
            departments: [{
              DepartmentId: departments.DepartmentId,
              DepartmentTitle: departments.DepartmentTitle,
            }]
    }; 
      const response = await masterApi.createDepartmentFromApi(JSON.stringify(payload));
      return response;
    } catch (error) {
      console.error("Error adding Department details:", error);
      throw error;
    }
  };

  const getAllCountries = async () => {  
    try {
      const response = await masterApi.getAllCountry();
  
      // Make sure to access the actual country list
      const countries = response?.data || []; // or response.data.data if nested further
      return countries.map(country => ({
        countryId: country.CountryId,
        countryName: country.CountryName,
        countryCode: country.CountryCode,
      }));
    } catch (error) {
      console.error("Error loading countries:", error);
      throw error;
    }
  };
  
  const addCountryDetails = async (country) => { 
    try { 
      const payload = {
        countries: [{
          CountryId: country.CountryId,
          CountryName: country.CountryName,
          CountryCode: country.CountryCode,
        }]
      };
      const response = await masterApi.createCountryFromApi(JSON.stringify(payload));
      return response;
    } catch (error) {
      console.error("Error adding country details:", error);
      throw error;
    }
  };
  
  const addCountryIfNotExists = async (country) => {
    const countries = await getAllCountries();
    const countryExists = countries.some(c => c.countryId === country.CountryId);
    if (!countryExists) {
      await addCountryDetails(country);
    }
  };

  const addCompanyDetails = async (companies) => {
    try {  
      // Prepare the payload with all company details
      // const companies = companiesArray.flat();
      const payload = {
        companies: companies.map(company => ({
          companyId: company.code,
          name: company.name,
          countryId: company.countryId,
          address: company.address,
          city: company.city,
          state: company.state,
          zipcode: company.zipcode,
          phone: company.phone,
          email: company.email,
          website: company.website,
          primaryContactFirstName: company.primaryContactFirstName,
          primaryContactLastName: company.primaryContactLastName,
          primaryContactEmail: company.primaryContactEmail,
          primaryContactPhone: company.PrimaryContactPhoneNo
        }))
      }; 
      const response = await masterApi.createCompanyFromApi(JSON.stringify(payload)); 
      return response;
    } catch (error) {
      console.error("Error adding company details:", error);
      throw error;
    }
  };

  const addAccountDetails = async (accountId) => {
    console.log("Account ID:", accountId);
    console.log("Account List:", accountLst);
    const accountData = accountLst.find(account => account.ClientId === accountId);
console.log("Account Data:", accountData);

  try {
    const payload = {
      id: accountData.ClientId,
      name: accountData.ClientName,
      address: accountData.Address || null,
      city: accountData.City || null,
      state: accountData.State || null,
      zipcode: accountData.ZipCode || null,
      phone: accountData.Phone || null,
      email: accountData.Email || null,
      website: accountData.Website || null,
      primaryContactFirstName: accountData.PrimaryContactFirstName || null,
      primaryContactLastName: accountData.PrimaryContactLastName || null,
      primaryContactEmail: accountData.PrimaryContactEmail || null,
      primaryContactPhone: accountData.PrimaryContactPhone || null,
      createdByUserId: accountData.createdByUserId,
    };

    const response = await masterApi.saveAccountDetailsFromTimeZone(JSON.stringify(payload));
    //const response = await createProjectAccountFromApi(payload);

    if (!response?.status || response.status !== 201) {
      console.warn("Failed to add account details");
    } else {
      console.log("Account added successfully");
    }

    return response;
  } catch (error) {
    if (error.response?.data?.message?.includes("unique")) {
      console.warn("Duplicate account ID or constraint violation");
    } else {
      throw error; // Unhandled error
    }
  }
};

  const onSubmit = async (data) => {
    setIsLoading(true); // Start loader

     await addAccountDetails(data.accountId);// add account details from timezone

    // debugger
      // Add the selected department details first
      const selectedDepartmentDetails = departmentLst.find(department => department.DepartmentId === String(data.departmentId));
      try {
          const departmentResponse = await addDepartmentDetails(selectedDepartmentDetails);
          if (!departmentResponse?.ok) {
              console.warn("Failed to add department details");
          }
      } catch (error) {
          if (error.message.includes("ID must be unique")) {
              console.warn("Duplicate department ID, continuing execution");
          } else {
              throw error; // Re-throw other errors
          }
      }     
  
    // Add the selected company details
    const selectedCompanyDetails = data.companyId.map(company => 
      companyLst.find(companyItem => companyItem.code === company.code)
    );
// Check and add missing countries
// for (const company of selectedCompanyDetails) {
//   const country = {
//     CountryId: company.countryId,
//     CountryName: countryLst.find(c => c.CountryId === company.countryId)?.CountryName ,
//     CountryCode: countryLst.find(c => c.CountryId === company.countryId)?.CountryCode 
//   };
//   await addCountryIfNotExists(country);
// }


  // Step 3: Check and add missing countries
  for (const company of selectedCompanyDetails) { 
    const countryId = company.countryId;
    const existingCountry = countryLst.find(c => c.CountryId === company.countryId);

    if (!existingCountry) {   
      const countryFromList = countryLstApi.find(c => c.CountryId === countryId);
      if (countryFromList) {
        const country = {
          CountryId: countryFromList.CountryId,
          CountryName: countryFromList.CountryName,
          CountryCode: countryFromList.CountryCode
        };

      // Add the new country
      await addCountryIfNotExists(country);

      // Refresh country list after insertion
      const response = await masterApi.getAllCountry(); // <- make sure this is available
      const updatedCountryList = response?.data ?? [];
      countryLst.length = 0;
      countryLst.push(...updatedCountryList);

      // Update company data with latest country info
      const updatedCountry = updatedCountryList.find(c => c.CountryId === countryId);
      if (updatedCountry) {
        company.CountryName = updatedCountry.CountryName;
        company.CountryCode = updatedCountry.CountryCode;
      }
    }
  }
    try {
      // const companyResponse = await addCompanyDetails(selectedCompanyDetails);
      const companyResponse = await addCompanyDetails([company]);
      if (!companyResponse?.ok) {
        console.warn("Failed to add company details");
      }
    } catch (error) {
      if (error.message.includes("ID must be unique")) {
        console.warn("Duplicate company ID, continuing execution");
      } else {
        throw error; // Re-throw other errors
      }
    }
  }

    if (data.experienceInYears === "") {
    data.experienceInYears = null; // or 0 if your DB allows it
  }

    const jobDetails = new JobDetailsDTO({ 
      jobCode: data.jobTitle,
      jobTitle: data.jobTitle,
      numberOfPositions: data.numberOfPositions,
      departmentId: data.departmentId,
      companyId: data.companyId?.map((qualification) => qualification.code),
      accountId: data.accountId,
      clientAccountManagerName: Array.isArray(data.clientAccountManagerName) 
        ? data.clientAccountManagerName?.map((value) => value.label)
        : data.clientAccountManagerName?.label || data.clientAccountManagerName,
      clientAccountManagerEmailId: data.clientAccountManagerEmailId,
      clientAccountManagerPhoneNo: data.clientAccountManagerPhoneNo,
      employmentTypeId: data.employmentTypeId,
      workMode: data.workMode,
      billability: data.billability,
      experienceInYears: data.experienceInYears,
      experienceInMonths: 0,
      workingHours: data.workingHours,
      fulfillmentDate: data.fulfillmentDate,
      priority: data.priority,
      recruiterId: data.recruiterId?.map((qualification) => qualification.code),
      accountManagerId: data.accountManagerId?.map((qualification) => qualification.code),
      approvalNeeded: !data.approvalNeeded,
      notes: data.notes,
      jobDescription: data.jobDescription,
      qualificationIds: data.qualificationIds?.map((qualification) => qualification.code),
      skillIds: data.skillIds?.map((qualification) => qualification.value),
      approverIds: data.approverIds?.map((qualification) => qualification.code),
      ownerIds: data.ownerIds?.map((qualification) => qualification.code),
      panelUserIds: data.panelUserIds?.map((qualification) => qualification.code),
      jobStatus: data.jobStatus||JobDetailStatusEnum.WAITINGFORAPPROVAL,
      locationIds : data.locationIds?.map((location) => location.value),
    });
    console.log("Form Data:", jobDetails);
    let response;
    console.log("isPublishClicked"+isPublishClicked);
    if (existingData) {
      jobDetails.jobDetailId = existingData;
      jobDetails.recordStatus = RecordStatusEnum.ACTIVE;
      if(!isPublished){
      if(data.approvalNeeded  ){
      //   jobDetails.jobStatus=JobDetailStatusEnum.SAVED;
      // }else{
        jobDetails.jobStatus=JobDetailStatusEnum.WAITINGFORAPPROVAL;
      }
    }
      if(isPublishClicked){
        if(!data.approvalNeeded){
          alert("Approval is pending. Please approve before publishing.");
          return;
        }
          if(!isPublished){
            jobDetails.jobStatus=JobDetailStatusEnum.OPEN;
          }
      }
      response = await jobApi.updateJobDetails(jobDetails);
      if (response?.ok) {
         setIsLoading(false); // Stop loader
        alert(response?.message);
        closePopup();
      } else {
         setIsLoading(false); // Stop loader
        alert("Something went wrong");
      }
    } else {
      if(data.approvalNeeded){
      //   jobDetails.jobStatus=JobDetailStatusEnum.SAVED;
      // }else{
        jobDetails.jobStatus=JobDetailStatusEnum.WAITINGFORAPPROVAL;
      }
      if(isPublishClicked){        
          jobDetails.jobStatus=JobDetailStatusEnum.OPEN;        
      }
      response = await jobApi.createJobDetails(jobDetails);
      console.log('API response :', response);
      if (response?.data?.ok) {
         setIsLoading(false); // Stop loader
        // alert(response?.data?.message);
        toast.success("Job created successfully", {
          position: "top-right",
          autoClose: 2000,
        });
        closePopup();
      } else {
         setIsLoading(false); // Stop loader
        // alert("Something went wrong");
        toast.error("Error creating job", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    }

  };
  

  const loadMasterData = async () => {
     setIsLoading(true); // Start loader
    let response = await masterApi.getAllCountry();

    const countryformattedData = response?.data.map((country) => ({
      CountryId: country.id,
      CountryName: country.name,
      CountryCode:country.code,                
    }));
    setCountryLst(countryformattedData);
    
      let responseApi = await apiService.getAllCountry();
      const countryformattedDataApi = responseApi?.map((country) => ({
        CountryId: country.CountryId,
        CountryName: country.CountryName,
        CountryCode:country.CountryCode,                
      }));
      setCountryLstApi(countryformattedDataApi);

    // let response = await masterApi.getActiveDepartments();
     response = await apiService.getActiveDepartments();
    // if (response?.data?.activeDepartments && Array.isArray(response.data.activeDepartments)) {
    //   setDepartmentLst(response.data.activeDepartments);
    // } 
    // if (Array.isArray(response)) {   
    const departmentformattedData = response?.map((department) => ({
      DepartmentId: department.DepartmentId,
      DepartmentTitle: department.DepartmentTitle,

     }));

      setDepartmentLst(departmentformattedData); 
    // }
    
    // else {
    //   console.error("No active departments found or response format is incorrect.");
    //   setDepartmentLst([]);
    // }
    // response = await masterApi.getActiveCompanies();
     response = await apiService.getActiveCompanies();
     const companyformattedData = response?.map((company) => ({
      name: company.CompanyName,
       code: company.CompanyId,
       countryId:company.CountryId,
       address:company.Address,
       city:company.City,
       state:company.State,
       zipcode:company.ZipCode,
       phone:company.Phone,
       email:company.Email,
       website:company.Website,
       primaryContactFirstName:company.PrimaryContactFirstName,
       primaryContactLastName:company.PrimaryContactLastName,
       primaryContactEmail:company.PrimaryContactEmail,
       PrimaryContactPhoneNo:company.PrimaryContactPhoneNo,

     }));

    // const companyformattedData = response?.data?.companyList?.map((company) => ({
    //   name: company.companyName,
    //   code: company.id
    // }));

    setCompanyLst(companyformattedData);

    //response = await masterApi.getActiveProjectAccounts(); 
    response = await apiService.getActiveAccounts(); 
    console.log(response);
    if (response && Array.isArray(response)) {


      setAccountLst(response);
    } else {
      console.error("No active project account found or response format is incorrect.");
      setAccountLst([]);
    }


    //  const [clientAccountManagerLst, setClientAccountManagerLst] = useState([]);
    response = await apiService.getClientAccountManagerLst(); 
    console.log(response);
    if (response && Array.isArray(response)) {
      const managerformattedData = response.map((item) => ({
        label: item.ClientManagerName,
        value: item.ClientId
      }));

      setClientAccountManagerLst(managerformattedData);
    } else {
      console.error("No project account managers found.");
      setClientAccountManagerLst([]);
    }


    response = await masterApi.getActiveEducationalQualification();
    const qualformattedData = response?.data?.activeEducationalQualificationList?.map((qual) => ({
      name: qual.title,
      code: qual.id
    }));
    setQualificationLst(qualformattedData);
    response = await masterApi.getActiveSkill();
    // Transform the data
    const skillsformattedData = response?.data?.activeSkillList?.map((skill) => ({
      label: skill.skillName,
      value: skill.id
    }));
    setSkillsLst(skillsformattedData);
    response = await masterApi.getActiveUsers();
    const userformattedData = response?.data?.users?.map((user) => ({
      name: user.firstName + ' ' + user.lastName,
      code: user.id
    }));
    setUsersLst(userformattedData);
    response = await masterApi.getActiveEmploymentTypes();
    const empTypeformattedData = response?.data?.activeEmploymentTypeList?.map((user) => ({
      name: user.title,
      code: user.id.toString()
    }));
    setemploymentTypeLst(empTypeformattedData);

    //Locations Binding
    let locationResponse = await masterApi.getActiveLoactions();
    // Transform the data
    const locationsformattedData = locationResponse?.data?.activeLocationList?.map((loc) => ({
      label: loc.locationName,
      value: loc.id
    }));
    setLocationsLst(locationsformattedData);

    if (existingData) {
      try {
        const response = await jobApi.getJobDetailById(existingData);
        const data = response?.data;
    
        console.log("Job Status:", data.jobStatus);
        console.log("Billability:", data.billability);
        console.log("accountId:", data.accountId );
    
        // Filter and map selected values
        const selectedQualifications = qualformattedData?.filter(option => 
          data?.qualificationIds.includes(option.code)
        );
        const selectedCompanies = companyformattedData?.filter(option =>
          data?.companyIds.includes(Number(option.code))
        );
        console.log("selectedCompanies:", selectedCompanies);
        const selectedJobOwner = userformattedData?.filter(option => 
          data?.ownerIds.includes(option.code)
        );
        const selectedRecruiters = userformattedData?.filter(option => 
          data?.recruiterIds.includes(option.code)
        );
        const selectedAccountManager = userformattedData?.filter(option => 
          data?.accountManagerIds.includes(option.code)
        );
        const selectedPanelUsers = userformattedData?.filter(option => 
          data?.panelUserIds.includes(option.code)
        );
        const selectedApprovers = userformattedData?.filter(option => 
          data?.approverIds.includes(option.code)
        );
    
        const selectedSkills = data.skillIds?.map((id) => {
          const matchingSkill = skillsformattedData.find((skill) => skill.value === id);
          return matchingSkill || { label: id, value: id };
        }) || [];

        const selectedLocations = data.locationIds?.map((id) => {
          const matchingLocation = locationsformattedData.find((loc) => loc.value === id);
          return matchingLocation || { label: id, value: id };
        }) || [];
        // debugger

        const selectedEmployementTypeIds = data?.employmentTypeId?.map(String);
        const clientManagerValue = Array.isArray(data.clientAccountManagerName) 
        ? data.clientAccountManagerName?.map((value) => value.label)
        : data.clientAccountManagerName?.label || data.clientAccountManagerName;
        const selectedclientAccountManager = {label: clientManagerValue, value: clientManagerValue};
    
        // Update state for isPublished
        setIsPublished(
  data.jobStatus === JobDetailStatusEnum.OPEN ||
  data.jobStatus === JobDetailStatusEnum.ONHOLD||
  data.jobStatus === JobDetailStatusEnum.CLOSED 
);

setIsEditAndApproved(
        !!existingData &&
        (data.jobStatus === JobDetailStatusEnum.OPEN ||
         data.jobStatus === JobDetailStatusEnum.ONHOLD ||
         data.jobStatus === JobDetailStatusEnum.CLOSED)
      );

    console.log(isPublished);
        // Reset form with data
        reset({
          jobTitle: data.jobTitle,
          numberOfPositions: data.numberOfPositions,
          departmentId: data.departmentId,
          companyId: selectedCompanies,
          //accountId: data.accountId,
          accountId: String(data.accountId),
          // employmentTypeId: data?.employmentTypeId?.toString(),
          clientAccountManagerName: selectedclientAccountManager,
          clientAccountManagerEmailId: data.clientAccountManagerEmailId,
          clientAccountManagerPhoneNo: data.clientAccountManagerPhoneNo,
          employmentTypeId: selectedEmployementTypeIds,
          workMode: data.workMode,
          billability: data.billability === 'billable',
          experienceInYears: data.experienceInYears,
          experienceInMonths: 0,
          workingHours: data.workingHours,
          fulfillmentDate: formatDate(data.fulfillmentDate),
          priority: data.priority,
          recruiterId: selectedRecruiters,
          accountManagerId: selectedAccountManager,
          approvalNeeded: data.approvalNeeded === 0,
          notes: data.notes,
          jobDescription: data.jobDescription,
          qualificationIds: selectedQualifications,
          skillIds: selectedSkills,
          approverIds: selectedApprovers,
          ownerIds: selectedJobOwner,
          panelUserIds: selectedPanelUsers,
          jobStatus: data.jobStatus,
          locationIds: selectedLocations,
        });
      } catch (error) {
        console.error("Error fetching job details:", error);
      }finally {
        setIsLoading(false); // Stop loader
      }
    }
    
  }

  // const handleChange = (selectedOption) => {
  //   setValue('accountId', selectedOption ? selectedOption.value : '');
  // };  

  
    
  useEffect(() => {
    //  setIsLoading(true); // Start loader
    // await loadMasterData();
    //  setIsLoading(true); // Start loader
    // //alert(isPublished);
const fetchAll = async () => {
    setIsLoading(true);
    await loadMasterData();
    setIsLoading(false);
  };
  fetchAll();

  }, [setValue, reset, employmentTypeId]);

  const clearSerachedUserList = () =>{
    setSearcheduserList([])
  }

  const filterSearch = (e) => {
    if(e.filter.length >= searchTextLimit){
      const searchedUser = usersLst.filter(user => user.name.toLocaleLowerCase().startsWith(e.filter.toLocaleLowerCase()))
      setSearcheduserList([...searchedUser])
    }else{
      setSearcheduserList([])
    }
  }


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="popup-container full-width-popup">
        <div
          className="shadeClose"
          onClick={() => {
            closePopup();
          }}
        ></div>
        <div className="popup-inner">
          <div className="inner-design">
             {isLoading && <ThreeDotLoader />}
            <div className="popup-header d-flex align-items-center gap2">
              <h2>{existingData?"Update Job":"Create Job"}</h2>
              <button
                type="button"
                className="ms-auto close-btn"
                onClick={() => {
                  closePopup();
                }}
              >
                <IoCloseOutline />
              </button>
            </div>

            <div className="popup-content">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-7 left-deck mb-3">
                  <div className="row">
                    {/* Job Title */}
                    <div className="col-12 col-md-6 mb-4 position-relative">
                      <label className="form-label" htmlFor="jobTitle">
                        Job Title <span className="asterisk danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.jobTitle ? "is-invalid" : ""}`}
                        id="jobTitle"
                        {...register("jobTitle", { required: true })}
                      />
                      {/* {errors.jobTitle && <div className="invalid-feedback position-absolute mt-0 position-absolute pe-4 mt-0 position-absolute pe-4 mt-0">{errors.jobTitle.message}</div>} */}
                    </div>
                    {/* No of Positions */}
                    <div className="col-6 col-sm-3 col-md-3 col-lg-2 mb-4 position-relative">
                      <label className="form-label" htmlFor="positions">
                        No of positions
                         <span className="asterisk danger">*</span> 
                      </label>
                      <input
                        type="number"
                        className={`form-control ${errors.numberOfPositions ? "is-invalid" : ""}`}
                        id="positions"
                        {...register("numberOfPositions", { required: "No of positions is required" })}
                        min={1} // Ensure at least 1 position
                      />
                      {errors.numberOfPositions && <div className="invalid-feedback position-absolute mt-0 position-absolute pe-4 mt-0">{errors.numberOfPositions.message}</div>}
                    </div>
                    
                    <div className="col-6 col-sm-4 col-md-3 mb-4 position-relative">
                    {existingData && (
                      <div>
                      <label className="form-label" htmlFor="jobStatus">
                        Job Status <span className="asterisk danger">*</span>
                      </label>
                      <select
                        className={`form-select ${errors.jobStatus ? "is-invalid" : ""}`}
                        {...register("jobStatus", { required: "Status is required" })}
                        defaultValue={isPublished ? existingData?.jobStatus : JobDetailStatusEnum.OPEN }
                      >
                        {Object.keys(JobDetailStatusEnum).map((key) => (
                          <option
                          key={key}
                          value={JobDetailStatusEnum[key]}
                          disabled={
                            // (JobDetailStatusEnum[key] === JobDetailStatusEnum.OPEN) || 
                            (JobDetailStatusEnum[key] === JobDetailStatusEnum.WAITINGFORAPPROVAL)
                          }
                        >
                          {JobDetailStatusEnumLabels[JobDetailStatusEnum[key]]}
                        </option>
                        ))}
                      </select>
                      {errors.jobStatus && <div className="invalid-feedback position-absolute mt-0">{errors.jobStatus.message}</div>}
                   
                    </div> )}
                      </div>
                    
                    {/* Department */}
                    <div className="col-12 col-sm-5 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="department">
                        Department <span className="asterisk danger">*</span>
                      </label>
                      <select
                        className={`form-select ${errors.departmentId ? "is-invalid" : ""}`}
                        {...register("departmentId", { required: "Department is required" })}
                      >
                        {/* <option value="">Select Department</option>
                        {departmentLst?.map((department) => (
                          <option key={department.id} value={department.id}>
                            {department.DepartmentTitle}
                          </option>
                        ))} */}
                        <option value="">Select Department</option>
                        {departmentLst?.map((department) => (
                          <option key={department.DepartmentId} value={department.DepartmentId}>
                            {department.DepartmentTitle}
                          </option>
                        ))}
                      </select>
                      {errors.departmentId && <div className="invalid-feedback position-absolute mt-0">{errors.departmentId.message}</div>}
                    </div>

                    {/* Company MultiSelect */}
                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="company">
                        Company <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-flex prime-holder">
                        <Controller
                          name="companyId"
                          control={control}
                          //defaultValue={[]} // Set the initial state as an empty array
                          rules={{ required: "Please select at least one company" }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              // options={companyLst}
                              options={searchedCompany}
                              optionLabel="name"
                              display="chip"
                              placeholder="Select Company"
                              maxSelectedLabels={3}
                              className={`w-full md:w-20rem form-control ${errors.companyId ? "is-invalid" : ""
                                }`}
                              onFilter={input => {
                                if(input.filter.length >= searchTextLimit){
                                  const matchedList = companyLst.filter(company => 
                                    company.name.toLocaleLowerCase().startsWith(input.filter.toLocaleLowerCase())
                                  )
                                  setSearchedCompany(matchedList)
                                }else{
                                  setSearchedCompany([])
                                }
                              }}
                              filter
                            />
                          )}
                        />
                      </div>
                      {errors.companyId && (
                        <div className="invalid-feedback position-absolute mt-0">{errors.companyId.message}</div>
                      )}
                    </div>
                    {/* Account  */}
                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="account">
                      Client Account <span className="asterisk danger">*</span>
                      </label>
                      {/* <select 
                        className={`form-select ${errors.accountId ? "is-invalid" : ""}`}
                        {...register("accountId", { required: "Account is required" })}
                      >
                        <option value="">Select Account</option>
                        {accountLst?.map((account) => (
                          <option key={account.id} value={account.id}>
                            {account.name}
                          </option>
                        ))}                        
                      </select> */}
                      
                      {/* <Select
                      className={`form-select ${errors.accountId ? "is-invalid" : ""}`}
                      {...register("accountId", { required: "Account is required" })}
                        options={options}
                        // onChange={handleChange}
                        placeholder="Select Account"
                        value={options.find(option => option.value === field.value)} // ✅ This is valid now
                        onChange={(selectedOption) => field.onChange(selectedOption.value)} // ✅ This is valid too
                        /> */}
                        <Controller
                          name="accountId"
                          control={control}
                          defaultValue={null}
                          rules={{ required: "Account is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={accounts}
                              classNamePrefix="react-select"
                              className={`multi-select-holder ${errors.accountId ? "is-invalid" : ""}`}
                              placeholder="Select Account"
                              value={options.find(option => option.value === field.value)} // Show label
                              onChange={(selectedOption) => field.onChange(selectedOption?.value)} // Store value only
                              onInputChange={(input, action) => {
                                if(input.length >= searchTextLimit){
                                  const matchedAccount = options.filter((option) => option.label.toLowerCase().startsWith(input.toLocaleLowerCase()));
                                  setAccounts(matchedAccount)
                                }else{
                                  setAccounts([])
                                }
                              }}
                              
                              isClearable
                            />
                          )}
                        />

                      {errors.accountId && <div className="invalid-feedback position-absolute mt-0">{errors.accountId.message}</div>}
                    </div>
                    {/* Employment Type */}
                    {/* <div className="col-12 col-md-12 mb-4 position-relative">
                      <fieldset class="position-relative">
                        <legend className="label-legend position-absolute"> <label className="form-label" htmlFor="employmenttype">
                          Employment Type <span className="asterisk danger">*</span>
                        </label></legend>
                        <div className="control-group">
                          <div className="d-flex gap-3 align-items-center justify-content-between flex-wrap">
                            {employmentTypeLst?.map((type) => (
                              <div className="form-check" key={type.code}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id={`employmentType${type.code}`}
                                  value={type.code}
                                  {...register("employmentTypeId", {
                                    validate: (value) =>
                                      value?.length > 0 || "Select at least one employment type",
                                  })}
                                />
                                <label className="form-label form-check-label mb-0" htmlFor={`employmentType${type.code}`}>
                                  {type.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </fieldset>


                      {errors.employmentTypeId && <div className="invalid-feedback position-absolute mt-0 d-block">{errors.employmentTypeId.message}</div>}
                    </div> */}

                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="clientAccountManagerName">
                        Client Account Manager<span className="asterisk danger">*</span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control}`}
                        id="accountManager"
                        {...register("accountManager", { required: false})}
                      /> */}
                      <div className="d-block prime-holder">
                        <Controller
                          name="clientAccountManagerName"
                          control={control}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <CreatableSelect
                              {...field}
                              isClearable
                              options={clientAccountManagers}
                              value={field?.value} // Show placeholder if empty
                              onChange={(selected) => field.onChange(selected)} // Sync changes
                              onCreateOption={(newOption) => {
                                const currentValue = Array.isArray(field.value) ? field.value : [];
                                field.onChange([...currentValue, { label: newOption, value: newOption }]);
                              }}
                              // onInputChange={(inputValue, { action }) => {
                              //   if (action === 'input-change') {
                              //     // Handle input change here
                              //     console.log('Input changed:', inputValue);
                              //     // You can add your custom logic here
                              //   }
                              // }}
                              onInputChange={(input, action) => {
                                if(input.length >= searchTextLimit){
                                  const matchedManager = clientAccountManagerLst.filter((option) => option.label.toLowerCase().startsWith(input.toLocaleLowerCase()));
                                  setClientAccountManagers(matchedManager)
                                }else{
                                  setClientAccountManagers([])
                                }
                              }}
                              placeholder="Search or add a new item..."
                              className={`w-full ${errors.clientAccountManagerName ? "is-invalid" : ""}`}
                              // isMulti
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="clientAccountManagerEmailId">
                      Client Manager Email
                      </label>
                      <input
                        type="text"
                        className={`form-control`}
                        id="clientAccountManagerEmailId"
                        {...register("clientAccountManagerEmailId", { required: false })}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="clientAccountManagerPhoneNo">
                      Client Manager Mobile
                      </label>
                      <input
                        type="text"
                        className={`form-control }`}
                        id="clientAccountManagerPhoneNo"
                        {...register("clientAccountManagerPhoneNo", { required: false })}
                      />
                    </div>

                    <div className="col-12 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="company">
                        Locations <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-block prime-holder">
                        <Controller
                          name="locationIds"
                          control={control}
                          rules={{
                            required: "Location is required",
                          }}
                          render={({ field }) => (
                            <CreatableSelect
                              {...field}
                              isClearable
                              options={locationsLst}
                              value={field?.value} // Ensure value is populated
                              onChange={(selected) => field.onChange(selected)} // Sync changes
                              onCreateOption={(newOption) => {
                                const currentValue = Array.isArray(field.value) ? field.value : [];
                                field.onChange([...currentValue, { label: newOption, value: newOption }]);
                              }}
                              onInputChange={(inputValue, { action }) => {
                                if (action === 'input-change') {
                                  // Handle input change here
                                  console.log('Input changed:', inputValue);
                                  // You can add your custom logic here
                                }
                              }}
                              placeholder="Search or add a new item..."
                              className={`w-full ${errors.locationIds ? "is-invalid" : ""}`}
                              isMulti
                            />
                          )}
                        />

                      </div>
                      {errors.locationIds && (
                        <div className="invalid-feedback position-absolute mt-0" >{errors.locationIds.message}</div>
                      )}
                    </div>
                       <div className="col-6 col-sm-2 col-md-2 mb-4 position-relative .text-center">
                      <label className="form-label" htmlFor='account'>Billable</label>
                      <div className="switch-holder">
                        <Controller
                          name="billability"
                          control={control}
                          defaultValue={false} // Set the initial state
                          render={({ field }) => (
                            <InputSwitch
                              checked={!!field.value}
                              onChange={(e) => field.onChange(e.value)}
                            />
                          )}
                        />
                      </div>
                    </div>
                    {/*EXP Required*/}
                    <div className="col-6 col-sm-4 col-md-3 mb-4 position-relative">
                      <label className="form-label" htmlFor="experience">
                        Exp. Required (Yrs)
                        {/* <span className="asterisk danger">*</span> */}
                      </label>
                      <select className={`form-select ${errors.experienceInYears ? "is-invalid" : ""}`}
                        {...register("experienceInYears")}
                      >
                        <option value="">Select</option>
                        {Array.from({ length: 26 }, (_, i) => {
                                // const year =  i+1;
                                // return (
                                // <option key={year} value={year}>
                                //     {year}
                                // </option>
                                // );
                                return (
                                <option key={i} value={i}>
                                  {i}
                                </option> );
                            })}
                      </select>
                      {/* <input
                        type="text"
                        className={`form-select ${errors.experienceInYears ? "is-invalid" : ""}`}
                        id="jobTitle"
                        {...register("experienceInYears", { required: "Experience required" })}
                      /> */}
                      {errors.experienceInYears && <div className="invalid-feedback position-absolute mt-0">{errors.experienceInYears.message}</div>}
                    </div>
                      <div className="col-6 col-sm-4 col-md-3 mb-4 position-relative">
                      <label className="form-label" htmlFor="experience">
                        Working Hours <span className="asterisk danger">*</span>
                      </label>
                      <select className={`form-select ${errors.workingHours ? "is-invalid" : ""}`}
                      {...register("workingHours", { required: "Experience required" })}
                      >
                        <option>2PM - 11PM</option>
                        <option>9AM - 6PM</option>
                        <option>10AM - 7PM</option>
                        <option>12AM - 9PM</option>
                      </select>
                      {/* <input
                        type="text"
                        className={`form-select ${errors.workingHours ? "is-invalid" : ""}`}
                        id="jobTitle"
                        {...register("workingHours", { required: "Experience required" })}
                      /> */}
                      {errors.workingHours && <div className="invalid-feedback position-absolute mt-0">{errors.workingHours.message}</div>}
                    </div>
                  <div className="col-12 col-md-12 mb-4 position-relative">
                    <fieldset className="position-relative">
                      <legend className="label-legend position-absolute">
                        <label className="form-label" htmlFor="employmenttype">
                          Employment Type <span className="asterisk danger">*</span>
                        </label>
                      </legend>
                      <div className="control-group">
                        <div className="d-flex gap-3 align-items-center justify-content-between flex-wrap">
                          {employmentTypeLst?.map((type) => (
                            <div className="form-check" key={type.code}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`employmentType${type.code}`}
                                value={type.code}
                                {...register("employmentTypeId", {
                                  validate: (value) =>
                                    value?.length > 0 || "Select at least one employment type",
                                })}
                              />
                              <label className="form-label form-check-label mb-0" htmlFor={`employmentType${type.code}`}>
                                {type.name}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </fieldset>

                    {errors.employmentTypeId && (
                      <div className="invalid-feedback position-absolute mt-0 d-block">
                        {errors.employmentTypeId.message}
                      </div>
                    )}
                  </div>

                



                    {/* Employment Type */}
                    <div className="col-12 col-md-12 mb-4 position-relative">
                      <fieldset className="position-relative h-100">
                        <legend className="label-legend position-absolute"> <label className="form-label" htmlFor="workmode">
                          Work Mode <span className="asterisk danger">*</span>
                        </label></legend>
                        <div className="control-group">
                          <div className="d-flex gap-3 align-items-center justify-content-between flex-wrap">
                            {["Remote", "Hybrid", "Office"].map((type, index) => (
                              <div className="form-check" key={index}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id={`workMode${index}`}
                                  value={type.toLowerCase()}
                                  {...register("workMode", {
                                    validate: (value) =>
                                      value?.length > 0 || "Select at least one workmode",
                                  })}
                                />
                                <label className="form-label form-check-label mb-0" htmlFor={`workMode${index}`}>
                                  {type}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </fieldset>

                      {errors.workMode && <div className="invalid-feedback position-absolute mt-0 d-block">{errors.workMode.message}</div>}
                    </div>
                   
                    {/* educational Qualifications */}
                    <div className="col-12 col-sm-6 col-md-6 mb-4 position-relative">
                      <label className="form-label" htmlFor="company">
                        Educational Qualifications <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-flex prime-holder">
                        <Controller
                          name="qualificationIds"
                          control={control}
                          defaultValue={qualificationLst?.filter(option => [1, 2].includes(option.id))}
                          rules={{ required: "Please select at least one approver" }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              options={qualificationLst}
                              optionLabel="name"
                              display="chip"
                              placeholder="Select "
                              maxSelectedLabels={3}
                              className={`w-full md:w-20rem form-control ${errors.qualificationIds ? "is-invalid" : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      {errors.qualificationIds && (
                        <div className="invalid-feedback position-absolute mt-0">{errors.qualificationIds.message}</div>
                      )}
                    </div>
                    {/* Skills*/}
                    <div className="col-12 col-md-6 mb-6 position-relative">
                      <label className="form-label" htmlFor="company">
                        Skills <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-block prime-holder">
                        <Controller
                          name="skillIds"
                          control={control}
                          rules={{
                            required: "Skill is required",
                          }}
                          render={({ field }) => (
                            <CreatableSelect
                              {...field}
                              isClearable
                              options={skillsLst}
                              value={field?.value} // Ensure value is populated
                              onChange={(selected) => field.onChange(selected)} // Sync changes
                              onCreateOption={(newOption) => {
                                const currentValue = Array.isArray(field.value) ? field.value : [];
                                field.onChange([...currentValue, { label: newOption, value: newOption }]);
                              }}
                              onInputChange={(inputValue, { action }) => {
                                if (action === 'input-change') {
                                  // Handle input change here
                                  console.log('Input changed:', inputValue);
                                  // You can add your custom logic here
                                }
                              }}
                              placeholder="Search or add a new item..."
                              className={`w-full ${errors.skillIds ? "is-invalid" : ""}`}
                              isMulti
                            />
                          )}
                        />

                      </div>
                      {errors.skillIds && (
                        <div className="invalid-feedback position-absolute mt-0" >{errors.skillIds.message}</div>
                      )}
                    </div>

                    {/* Job Title */}
                  

                    {/* Job Title */}
                    <div className="col-6 col-sm-4 col-md-3 mb-4 position-relative">
                      <label className="form-label" htmlFor="experience">
                        Fulfilment Date <span className="asterisk danger">*</span>
                      </label>
                      <input
                        type="date"
                        className={`form-control ${errors.fulfillmentDate ? "is-invalid" : ""}`}
                        id="fulfilmentdate"
                        {...register("fulfillmentDate", { required: "Fulfilment Date required" })}
                        min={new Date().toISOString().split('T')[0]} // Restrict to today or later
                      />
                      {errors.fulfillmentDate && <div className="invalid-feedback position-absolute mt-0">{errors.fulfillmentDate.message}</div>}
                    </div>
                    {/* Account  */}
                    <div className="col-4 col-sm-4 col-md-3 mb-4 position-relative">
                      <label className="form-label" htmlFor="account">
                        Priority <span className="asterisk danger">*</span>
                      </label>
                      <select
                        className={`form-select ${errors.priority ? "is-invalid" : ""}`}
                        id="priority"
                        {...register("priority", { required: "Please select a priority level" })}
                        
                      >
                        <option value="">Select Priority</option>
                        {Object.keys(PriorityEnum).map((key) => (
                          <option key={key} value={PriorityEnum[key]}>
                            {PriorityEnumLabels[PriorityEnum[key]]}
                          </option>
                        ))}
                      </select>
                      {errors.priority && (
                        <div className="invalid-feedback position-absolute mt-0">{errors.priority.message}</div>
                      )}
                    </div>
                    {/* Account  */}
                    <div className="col-8 col-sm-6 col-md-6 mb-4 position-relative">
                      <label className="form-label" htmlFor="jobowner">
                        Job Owner <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-flex prime-holder">
                        <Controller
                          name="ownerIds"
                          control={control}
                          defaultValue={[]} // Set the initial state as an empty array
                          rules={{ required: "Please select at least one job owner" }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              // options={usersLst}
                              options={searchedUserList}
                              optionLabel="name"
                              display="chip"  
                              placeholder="Select Job  Owner"
                              maxSelectedLabels={3}
                              filter
                              className={`w-full md:w-20rem form-control ${errors.ownerIds ? "is-invalid" : ""
                                }`}
                              onFilter={filterSearch}
                              onFocus={clearSerachedUserList}
                            />
                            // <Select
                            //   {...field}
                            //   options={searchedUserList}
                            //   classNamePrefix="react-select"
                            //   className={`multi-select-holder ${errors.accountId ? "is-invalid" : ""}`}
                            //   placeholder="Select Account"
                            //   isMulti
                            //   // value={options.find(option => option.value === field.value)} // Show label
                            //   onChange={(selectedOption) => field.onChange(selectedOption?.value)} // Store value only
                            //   onInputChange={(input, {action}) => {
                            //     const matchedUser = usersLst.filter((user) => user.name.toLocaleLowerCase().includes(input.toLocaleLowerCase()));
                            //     setSearcheduserList(matchedUser)
                            //       var a = 0;
                            //   }}
                              
                              // isClearable
                            // />
                          )}
                        />
                      </div>
                      {errors.ownerIds && <div className="invalid-feedback position-absolute mt-0">{errors.ownerIds.message}</div>}
                    </div>
                    {/* Account  */}
                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="recruiter">
                        Recruiter <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-flex prime-holder">
                        <Controller
                          name="recruiterId"
                          control={control}
                          defaultValue={[]} // Set the initial state as an empty array
                          rules={{ required: "Please select at least one recruiter" }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              // options={usersLst}
                              options={searchedUserList}
                              optionLabel="name"
                              display="chip"
                              placeholder="Select Recruiter"
                              maxSelectedLabels={3}
                              filter
                              className={`w-full md:w-20rem form-control ${errors.recruiterId ? "is-invalid" : ""
                                }`}
                              onFilter={filterSearch}
                              onFocus={clearSerachedUserList}
                            />
                          )}
                        />
                      </div>
                      {errors.recruiterId && <div className="invalid-feedback position-absolute mt-0">{errors.recruiterId.message}</div>}
                    </div>
                    {/* Account  */}
                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="accountManager">
                        Account Manager<span className="asterisk danger">*</span>
                      </label>
                      <div className="d-flex prime-holder">
                        <Controller
                          name="accountManagerId"
                          control={control}
                          defaultValue={[]} // Set the initial state as an empty array
                          rules={{ required: "Please select at least one Account Manager" }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              // options={usersLst}
                              options={searchedUserList}
                              optionLabel="name"
                              display="chip"
                              placeholder="Select Account Manager"
                              maxSelectedLabels={3}
                              filter
                              className={`w-full md:w-20rem form-control ${errors.accountManagerId ? "is-invalid" : ""
                                }`}
                              onFilter={filterSearch}
                              onFocus={clearSerachedUserList}
                            />
                          )}
                        />
                      </div>
                      {errors.accountManagerId && <div className="invalid-feedback position-absolute mt-0">{errors.accountManagerId.message}</div>}
                    </div>
                    {/* Skills*/}
                    <div className="col-12 col-sm-6 col-md-4 mb-4 position-relative">
                      <label className="form-label" htmlFor="company">
                        Interview Panel <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-flex prime-holder">
                        <Controller
                          name="panelUserIds"
                          control={control}
                          defaultValue={[]} // Set the initial state as an empty array
                          rules={{ required: "Please select at least one interview pannel" }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              // options={usersLst}
                              options={searchedUserList}
                              optionLabel="name"
                              display="chip"
                              placeholder="Select Interview Panel"
                              maxSelectedLabels={3}
                              filter
                              className={`w-full md:w-20rem form-control ${errors.panelUserIds ? "is-invalid" : ""
                                }`}
                              onFilter={filterSearch}
                              onFocus={clearSerachedUserList}
                            />
                          )}
                        />
                      </div>
                      {errors.panelUserIds && (
                        <div className="invalid-feedback position-absolute mt-0">{errors.panelUserIds.message}</div>
                      )}
                    </div>
                    {/* Skills*/}
                    <div className="col-md-12 position-relative">
                      <fieldset className="position-relative">
                        <legend className="label-legend position-absolute"> 
                          Approval Details</legend>
                        <div className="control-group">
                          <div className="row">
                            <div className="col-9 col-sm-9 col-md-8">
                            <label className="form-label" htmlFor="jobowner">
                       Approver <span className="asterisk danger">*</span>
                      </label>
                              <div className="d-flex prime-holder">
                                <Controller
                                  name="approverIds"
                                  control={control}
                                  defaultValue={[]} // Set the initial state as an empty array
                                  rules={{ required: "Please select at least one approver" }}
                                  render={({ field }) => (
                                    <MultiSelect
                                      {...field}
                                      // options={usersLst}
                                      options={searchedUserList}
                                      optionLabel="name"
                                      display="chip"
                                      placeholder="Select Approver"
                                      maxSelectedLabels={3}
                                      filter
                                      className={`w-full md:w-20rem form-control ${errors.approverIds ? "is-invalid" : ""
                                        }`}
                                      onFilter={filterSearch}
                                      onFocus={clearSerachedUserList}
                                    />
                                  )}
                                />
                              </div>
                              {errors.approverIds && (
                                <div className="invalid-feedback position-absolute mt-0">{errors.approverIds.message}</div>
                              )}
                            </div>
                            <div className="col-3 col-sm-3 col-md-4">
                              <label className="form-label" htmlFor="account">Approved</label>
                              <div className="switch-holder">
                                <Controller
                                  name="approvalNeeded"
                                  control={control}
                                  defaultValue={false} // Set the initial state
                                  render={({ field }) => (
                                    <InputSwitch
                                      checked={!!field.value}
                                      onChange={(e) => field.onChange(e.value)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            {/* Conditionally render Notes based on approvalNeeded */}
                            {watch("approvalNeeded") && (
  <div className="col-12 col-md-12 mt-4 position-relative">
    <label className="form-label" htmlFor="notes">
      Notes{!isEditAndApproved && <span className="asterisk danger">*</span>}
    </label>
    <textarea
      className={`form-control h-100 ${errors.notes ? "is-invalid" : ""}`}
      placeholder="Notes"
      id="jobTitle"
      {...register("notes", 
        !isEditAndApproved 
          ? { required: "Notes are required when approval is needed" }
          : {}
      )}
    ></textarea>
    {errors.notes && (
      <div className="invalid-feedback position-absolute mt-0">
        {errors.notes.message}
      </div>
    )}
  </div>
)}
                          </div>





                        </div>
                      </fieldset>
                    </div>

                  </div>
                </div>

                <div className="col-12 col-md-12 col-lg-5 right-deck">
                  <div className="row h-100">

                    {/* Job Title */}
                    <div className="col-12 col-md-12 mb-4 position-relative">
                      <label className="form-label" htmlFor="textarea">
                        Job Description <span className="asterisk danger">*</span>
                      </label>
                      <Controller
                        name="jobDescription"
                        control={control}
                        rules={{
                          required: "Job Description is required"
                        }}
                        render={({ field }) => (
                          <Editor
                            value={field?.value}
                            onTextChange={(e) => field.onChange(e.htmlValue)}
                            className={` form-control h-100 border-0 p-0 ${errors.jobDescription ? "is-invalid" : ""}`}
                          />
                        )}
                      />
                      {errors.jobDescription && (
                        <div className="invalid-feedback position-absolute mt-0">{errors.jobDescription.message}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="popup-footer position-absolute w-100 d-flex">
              <div className="ms-auto d-flex gap-2">
                <button type="button" className="btn btn-dark btn-lg" onClick={closePopup}>
                  Cancel
                </button>
                {!approvalNeeded ? (
               <button type="submit" className="btn btn-primary btn-xl" onClick={() => {
                  console.log(JobDetailStatusEnum)
                  setValue('jobStatus', JobDetailStatusEnum.WAITINGFORAPPROVAL)}}>
                 Submit for Approval
                </button>
                ) : (
                <button
                  type="submit"
                  className="btn btn-success btn-lg"
                  onClick={() => setIsPublishClicked(true)}
                >
                  {existingData && isPublished ? 'Update' : 'Save & Publish'}
              </button>
               )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
